import { css, cx } from '@emotion/css';

import { humanizeDuration } from '@phoenix/team-m/dashboard/frontend/shared/humanize';
import { DSText } from '@stihl-design-system/components';

export const RuntimeExtensionBar = ({ basePercentage, extendedPercentage, className = '', runtimeIncrease }) => (
  <div className={cx('relative flex w-full', { 'pt-3': !!runtimeIncrease }, className)}>
    {basePercentage > 0 && (
      <>
        <DSText
          weight="bold"
          className={cx(
            'absolute -translate-y-full text-blue whitespace-nowrap',
            css`
              left: ${basePercentage - (basePercentage > 80 ? 5 : 0)}%;
            `
          )}
        >
          + {humanizeDuration(runtimeIncrease)}
        </DSText>
        <div className="rounded-l bg-blue-deep p-1" style={{ width: `${basePercentage}%` }} />
      </>
    )}
    <div
      className={cx('rounded-r p-1', !basePercentage ? 'rounded-l bg-blue-deep' : 'bg-blue')}
      style={{ width: `${extendedPercentage}%` }}
    />
  </div>
);
